import "./LogoSlider.css";
const LogoSlider = ({ data }) => {
  const duplicatedData = [...data, ...data, ...data];
  return (
    <div
      className="internships-jobs-section"
      style={{ background: "#F0FBFF", padding: "20px 0" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <div className="logo-slider-container" style={{ maxWidth: "85vw", width: "100%" }}>
          <div className="logo-slider-track">
            {duplicatedData?.map((item, index) => (
              <div className="logo-slide" key={`${item}-${index}`}>
                <img
                  src={item}
                  alt="logo"
                  style={{
                    height: "100px",
                    width: "100px",
                    objectFit: "contain",
                    transition: "transform 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.1)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default LogoSlider;